<template>
  <div>
    <v-form @submit.prevent="sendForm">
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col class="body-1 text--secondary font-weight-bold" cols="4">{{
                  $vuetify.lang.t('$vuetify.profile.cols.fullName.title') }}
                </v-col>
                <v-col
                  class="body-1"
                  cols="8"
                >
                  {{ form.fullName }}
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-text-field
              :error="!_.isNull(apiFormErrors['fullName'])"
              :error-messages="!_.isEmpty(errorsFullname)?errorsFullname:apiFormErrors['fullName']"
              @blur="$v.form.fullName.$touch()"
              @input="$v.form.fullName.$touch()"
              v-model="form.fullName"
              autocomplete="off"
            ></v-text-field>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col class="body-1 text--secondary font-weight-bold" cols="4">{{
                  $vuetify.lang.t('$vuetify.profile.cols.phone.title')
                  }}
                </v-col>
                <v-col
                  class="body-1"
                  cols="8"
                >
                  {{ form.phone }}
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-text-field
              :error="!_.isNull(apiFormErrors['phone'])"
              :error-messages="!_.isEmpty(errorsPhone)?errorsPhone:apiFormErrors['phone']"
              @blur="$v.form.phone.$touch()"
              @input="$v.form.phone.$touch()"
              v-model="form.phone"
              autocomplete="off"
            ></v-text-field>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col class="body-1 text--secondary font-weight-bold" cols="4">{{
                  $vuetify.lang.t('$vuetify.profile.cols.email.title')
                  }}
                </v-col>
                <v-col
                  class="body-1"
                  cols="8"
                >
                  {{ form.email }}
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-text-field
              :error="!_.isNull(apiFormErrors['email'])"
              :error-messages="!_.isEmpty(errorsEmail)?errorsEmail:apiFormErrors['email']"
              @blur="$v.form.email.$touch()"
              @input="$v.form.email.$touch()"
              v-model="form.email"
              autocomplete="off"
            ></v-text-field>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <v-row no-gutters>
                <v-col class="body-1 text--secondary font-weight-bold" cols="4">{{
                  $vuetify.lang.t('$vuetify.profile.cols.address.title')
                  }}
                </v-col>
                <v-col
                  class="body-1"
                  cols="8"
                >
                  {{ form.address }}
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-text-field
              :error="!_.isNull(apiFormErrors['address'])"
              :error-messages="!_.isEmpty(errorsAddress)?errorsAddress:apiFormErrors['address']"
              @blur="$v.form.address.$touch()"
              @input="$v.form.address.$touch()"
              v-model="form.address"
              autocomplete="off"
            ></v-text-field>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row>
        <v-col align="right">
          <v-btn
            @click="dialogForm.show = true"
            color="red"
            text
          >{{ $vuetify.lang.t('$vuetify.profile.btn.password.title') }}
          </v-btn>
          <v-btn
            :loading="loadingBtn"
            color="secondary"
            text
            type="submit"
          >{{ $vuetify.lang.t('$vuetify.btn.save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <change-password :dialog="dialogForm"></change-password>
  </div>
</template>

<script>
  import FormMixin from '../../mixins/Common/Forms';
  import {required, maxLength, email} from "vuelidate/lib/validators";
  import {isPhone} from "../../helpers/Validators";
  import URLPath from "../../helpers/URL";
  import ChangePassword from "./ChangePassword";

  export default {
    mixins: [FormMixin],
    props: {
      form: {
        type: Object,
        default: function () {
          return {
            username: null,
            fullName: null,
            phone: null,
            address: null,
            email: null
          };
        }
      }
    },
    name: "Form",
    data: () => ({
      loadingBtn: false,
      dialogForm: {
        title: "$vuetify.profile.password.title",
        show: false,
        saveBtnTitle: "$vuetify.btn.save",
        action: "create"
      }
    }),
    created() {
      this.form.username = this.$auth.user().username;
      this.form.fullName = this.$auth.user().profile.fullName;
      this.form.phone = this.$auth.user().profile.phone;
      this.form.address = this.$auth.user().profile.address;
      this.form.email = this.$auth.user().profile.email;
    },
    validations() {
      let validators = {
        form: {
          fullName: {required, maxLength: maxLength(100)},
          email: {required, email},
          phone: {required, isPhone},
          address: {
            required,
            maxLength: maxLength(50),
          }
        }
      };
      return validators;
    },
    methods: {
      sendForm() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let self = this;
          this.loadingBtn = true;
          this.save(this.getFormParam())
            .then(() => {
              self.$store.dispatch("setNotification", {
                status: true,
                message: self.$vuetify.lang.t("$vuetify.success_form")
              });
              this.$auth.fetch();
            }).catch(() => {
            this.$forceUpdate();
          }).finally(() => {
            self.loadingBtn = false;
          })
        }
      },
      getFormParam() {
        let params = {};
        params["url"] = URLPath.PROFILE.EDIT.URI;
        params["data"] = this._.omit(this.form, ['username']);
        params["method"] = URLPath.PROFILE.EDIT.METHOD;
        return params;
      }
    },
    computed: {
      errorsFullname() {
        let errors = [];
        if (!this.$v.form.fullName.$dirty) return errors;

        !this.$v.form.fullName.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.profile.cols.fullName.required")
        );

        !this.$v.form.fullName.maxLength &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.profile.cols.fullName.length", [3], [100])
        );

        return errors;
      },
      errorsPhone() {
        let errors = [];
        if (!this.$v.form.phone.$dirty) return errors;

        !this.$v.form.phone.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.users.cols.phone.required")
        );

        !this.$v.form.phone.isPhone &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.users.cols.phone.phone")
        );

        return errors;
      },
      errorsEmail() {
        let errors = [];
        if (!this.$v.form.email.$dirty) return errors;

        !this.$v.form.email.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.users.cols.email.required")
        );

        !this.$v.form.email.email &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.users.cols.email.email")
        );

        return errors;
      },
      errorsAddress() {
        let errors = [];
        if (!this.$v.form.address.$dirty) return errors;

        !this.$v.form.address.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.users.cols.address.required")
        );

        !this.$v.form.address.maxLength &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.users.cols.address.maxLength", [50])
        );

        return errors;
      }
    },
    components: {
      ChangePassword
    }
  }
</script>

<style scoped>

</style>
